import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }

  getAgendaList() {
      var request = {
          URL: "agenda"
      }
      return this.httpService.get(request);

      // return this.http.get(environment.pssUrl + 'agenda')
      // .map(res => res.json());
  }




  getpredefinedTask() {
      // return this.http.get(environment.pssUrl + 'predefinedAllTaskList')
      // .map(res => res.json());
      var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
      var request = {
         // URL: "predefinedCompanyTaskList/" + libraryTasklistAdmin
         URL: "predefinedCompanyTaskList/"
          
      }
      return this.httpService.get(request);
  }

  getSelectedTask(editedID: string) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'agenda/selectedTask/' + editedID, { headers: headers })
          .map((res: Response) => res.json());
  }

  addAgenda(newAgenda) {

      var request = {
          URL: "agenda/add",
          DATA: newAgenda
      }
      return this.httpService.post(request);
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.post(environment.pssUrl + 'agenda/add', JSON.stringify(newAgenda), { headers: headers })
      //     .map(res => res.json());
  }

  

  uploadJarFile(agendaDetails){
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)

      return this.http.post(environment.nonValidateUrl + 'agenda/uploadJar', agendaDetails, { headers: headers }).map((res: Response) => res.json());
      // var request = {
      //     URL:'agenda/uploadJar',
      //     DATA:agendaDetails
      // }
      // return this.httpService.post(request);
     }

  updateAgenda(newAgenda) {
      var request = {
          URL: 'agenda/edit/' + newAgenda._id,
          DATA: newAgenda
      }
      return this.httpService.post(request);
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'agenda/edit/'+newAgenda._id, JSON.stringify(newAgenda), { headers: headers })
      //     .map(res => res.json());
  }

  uploadIMG(rawBody) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      console.log('JSON.stringify(formData)', rawBody);
      return this.http.post(environment.pssServerUrl + 'agenda/UploadFiles', rawBody, { headers: headers })
      .map((res: Response) => res.json());
  }

  // getAgendaListExceptGivenMeetingType(meetingTypeID){
  //     return this.http.get(environment.pssUrl + 'agenda/ExceptGivenMeetingType/'+meetingTypeID)
  //     .map(res => res.json());
  // }

  getAgendaLibrary(categoryIDArray, meetingTypeID) {
      var request = {
          URL: "agenda/agendaStore/agendaList/" + meetingTypeID,
          DATA: categoryIDArray,

      }
      return this.httpService.post(request);
      // return this.http.get(environment.pssUrl + 'agenda/agendaStore/agendaList')
      // .map(res => res.json());
  }

  getAgendaLibraryForPredefinedCommittee(categoryIDArray, meetingTypeID) {
      var request = {
          URL: "agenda/agendaStore/agendaList/predefinedCommittee/" + meetingTypeID,
          DATA: categoryIDArray,
      }
      return this.httpService.post(request);
  }

  getAgendaOpenLibrary(meetingTypeID) {
      var request = {
          URL: "agenda/agendaStore/OpenagendaList/" + meetingTypeID
      }
      return this.httpService.post(request);
      // return this.http.get(environment.pssUrl + 'agenda/agendaStore/agendaList')
      // .map(res => res.json());
  }

  downloadDOCS(_id) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      var ret = this.http.get(environment.pssServerUrl + 'agenda/download/' + _id, { headers: headers });
      return ret;
  }

  downloadDocMin(_id) {
      var token = localStorage.getItem('token')
      var ret = this.http.get(environment.pssServerUrl + 'agenda/downloadMin/' + _id + '/' + token);
      return ret;
  }



  getAgendaDetaisByID(agendaID: string) {
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.get(environment.pssUrl + 'agenda/' + agendaID)
      //     .map(res => res.json());

      var request = {
          URL: "getAgendaDetaisByID/" + agendaID
      }
      return this.httpService.post(request)
      // .map(res => res.json());
  }

  getMeetingOnTypeSelect(meetingTpeID) {
      var request = {
          URL: "meetingType/meetingByMeetingType/" + meetingTpeID,

      }
      return this.httpService.post(request);

      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.get(environment.pssUrl + 'meetingType/meetingByMeetingType/' + meetingTpeID)
      // .map(res => res.json());
  }

  addGroupIndex(data) {
      var request = {
          URL: 'indexgrouping/addGrouping',
          DATA: data
      }
      return this.httpService.post(request);
  }

  getGroupIndex() {
      var request = {
          URL: "indexgrouping/getGrouping"

      }
      return this.httpService.get(request);
  }

  getGroupIndexById(groupId) {
      var request = {
          URL: "indexgrouping/getGroupDataById/" + groupId

      }
      return this.httpService.get(request);
  }

  getAgendaListBySearchParams(searchParmJson) {

      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'agenda/search/', searchParmJson, { headers: headers })
      .map((res: Response) => res.json());
  }
  

  // getAgendaTypeSearch
  getAgendaTypeSearch(searchParm) {

      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'agenda/getAgendaTypes?searchString='+searchParm, { headers: headers })
          .map((result: Response) => result.json());
  }

  deleteAgenda(agenda_id) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'agenda/delete/' + agenda_id, { headers: headers })
          .map((res: Response) => res.json());
  }

  deleteProcessFromAgenda(processId, AgendaID,) {
      var request = {
          URL: "agenda/deleteProcessByID/" + processId + '/' + AgendaID,

      }
      return this.httpService.get(request);

  }

  getAgendaDetaisFromMeetingByID(meetingId, agendaID: string) {
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.get(environment.pssUrl + 'meeting/Libraryagenda/' + meetingId + '/' + agendaID)
      //     .map(res => res.json());
      var request = {
          URL: 'meeting/Libraryagenda/' + meetingId + '/' + agendaID
      }
      return this.httpService.post(request);
  }


  updateAgendaInMeeting(meetingId, newAgenda) {

      var request = {
          URL: 'agendaMeeting/edit/' + meetingId + '/' + newAgenda._id,
          DATA: newAgenda
      }
      return this.httpService.post(request);

      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'agendaMeeting/edit/'+meetingId+'/'+newAgenda._id, JSON.stringify(newAgenda), { headers: headers })
      //     .map(res => res.json());
  }

  getDatatableData(data) {
      // return this.http.get(environment.pssUrl + 'predefinedAllTaskList')
      // .map(res => res.json());
      var request = {
          URL: "dataTable/agendaWithSearching",
          DATA: data
      }
      return this.httpService.get(request);
  }

  getAgendaListForDataTable(data) {
    var request = {
      URL: "dataTable/agendaWithSearching",
      DATA: data
    };
    return this.httpService.post(request);
  }


  addBulkAgendaToMeetingIn(data) {
      var request = {
          URL: "agenda/addBulkAgendaInMeeting",
          DATA: data
      }
      return this.httpService.post(request);
  }

  deleteBulkAgenda(data) {
      var request = {
          URL: "agenda/deleteBulkAgenda",
          DATA: data
      }
      return this.httpService.post(request);
  }

  downloadLibraryAgendaDOCS(_id, agendaId, type) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      var ret = this.http.get(environment.pssServerUrl + 'meeting/downloadIndividual/' + _id + '/' + agendaId + '/' + type + '/' + token, { headers: headers });
      return ret;
  }

  updateAgendaDocumentInDB(DocumentManagement) {
      var request = {
          URL: 'agenda/addAgendaDocumentInDocumentManagement',
          DATA: DocumentManagement
      }
      return this.httpService.post(request);
  }

  updateGroupIndex(data) {
      var request = {
          URL: 'indexgrouping/updateAgendaGroup',
          DATA: data
      }
      return this.httpService.post(request);
  }

  deleteAgendaGroup(groupId) {
      var request = {
          URL: "indexgrouping/deleteAgendaGroup/" + groupId

      }
      return this.httpService.get(request);
  }
  getAgendaLibraryByDefaultCategory(meetingTypeID, categoryID) {
      var request = {
          URL: "agenda/agendaStore/agendaListByDefaultCategory/" + meetingTypeID + "/" + categoryID
      }
      return this.httpService.post(request);
  }

  /**
   * Content-based Lucene search for agendas
   * @param payload - Search query parameters
   * @returns Observable with search results including highlighted snippets
   */
  searchAgendaContentLucene(payload: { query: string; page: number; pageSize: number }) {
      var companyId = '';
      try {
          var companyDetails = JSON.parse(localStorage.getItem('companyDetails') || 'null');
          companyId = companyDetails && companyDetails.companyID ? companyDetails.companyID : '';
      } catch (e) {
          companyId = '';
      }
      var request = {
          URL: 'agenda/content-based-search',
          DATA: payload
      };
      return this.httpService.post(request, { companyId: companyId });
  }
}